export default __webpack_public_path__ + "static/compass-40b4d84929b7f0bb95e9cbeca358d9ff.svg";